import { DesignConflictItem, DesignConflictSection } from '../types';

function mapItems(
  items: DesignConflictItem[],
  callback: (item: DesignConflictItem) => DesignConflictItem | void
): DesignConflictItem[] {
  return items.map((item) => {
    item = { ...item };
    return callback(item) ?? item;
  });
}

export function mapDesignConflictItems(
  sections: DesignConflictSection[],
  callback: (item: DesignConflictItem) => DesignConflictItem | void
): DesignConflictSection[] {
  return sections.map((section) => {
    section = { ...section };
    if ('items' in section) {
      section.items = mapItems(section.items, callback);
    } else {
      section.subsections = section.subsections.map((subsection) => {
        return {
          ...subsection,
          items: mapItems(subsection.items, callback)
        };
      });
    }
    return section;
  });
}
